export default __webpack_public_path__ + "static/media/fullscreen-pink-14px.13639f80.svg";